import { ACTION_FETCH_TRANSLATIONS_PENDING, ACTION_FETCH_TRANSLATIONS_SUCCESS, ACTION_FETCH_TRANSLATIONS_ERROR } from 'actions/admin-translation/action.translations';

const initialState = {
    translationsPending: false,
    translations: [],
    translationsError: null
}

export default function translationsReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_FETCH_TRANSLATIONS_PENDING:
            return {
                ...state,
                translationsPending: true
            }
        case ACTION_FETCH_TRANSLATIONS_SUCCESS:
            return {
                ...state,
                translationsPending: false,
                translations: action.translations
            }
        case ACTION_FETCH_TRANSLATIONS_ERROR:
            return {
                ...state,
                translationsPending: false,
                translationsError: action.translationsError
            }
        default:
            return state;
    }
}

export const getTranslations = state => state.translationsReducer.translations;
export const getTranslationsPending = state => state.translationsReducer.translationsPending;
export const getTranslationsError = state => state.translationsReducer.translationsError;
